import versionJson from 'src/version.json';

export const isProduction = process.env.REACT_APP_PROJECT_ID === 'gooduncles-10f09';

export const version = isProduction ? versionJson.prod : versionJson.dev;

export const logArt = 'gooduncles';

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID === 'null' ? undefined : process.env.REACT_APP_MEASUREMENT_ID,
};

export const imageBaseUrl = 'https://firebasestorage.googleapis.com/v0/b/gooduncles-10f09.appspot.com/o/gu-files';
